import styled from "styled-components";
import { Container } from "manifest-components/src/Containers";
import { globalCSSVars } from "manifest-components/src/Styles/globals";

const AppContainer = styled(Container)`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  width: ${globalCSSVars.desktopWidth};
`;

export default AppContainer;
